import script from "./MonthlyTripRowDataTable.vue?vue&type=script&setup=true&lang=js"
export * from "./MonthlyTripRowDataTable.vue?vue&type=script&setup=true&lang=js"

import "./MonthlyTripRowDataTable.vue?vue&type=style&index=0&id=52e731a1&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52e731a1"]])

export default __exports__